import dayjs from "dayjs";
import customParseFormat from "dayjs/plugin/customParseFormat";
import { jwtDecode } from "jwt-decode";



dayjs.extend(customParseFormat);
const permissions = JSON.parse(localStorage.getItem("permissions")) || [];


export default function formatDateFr(dateString) {
  if (!dateString) return ""; // sécurité si la date est vide ou null

  const date = new Date(dateString);

  return date.toLocaleDateString("fr-FR", {
    day: "numeric",    // jour sans zéro devant
    month: "long",     // mois en toutes lettres
    year: "numeric"    // année sur 4 chiffres
  });
}

export function parseDateTime(dateString) {
  if (!dateString) return null;

  const date = dayjs(dateString, "YYYY-MM-DD HH:mm:ss", true); // strict parsing
  return date.isValid() ? date : null;
}

// Fonction utilitaire pour générer un gradient aléatoire
const randomGradient = () => {
  const getColor = () =>
    `rgb(${Math.floor(Math.random() * 256)}, ${Math.floor(
      Math.random() * 256
    )}, ${Math.floor(Math.random() * 256)})`;
  return `linear-gradient(90deg, ${getColor()}, ${getColor()})`;
};


export function formatMontant(value) {
  if (!value && value !== 0) return "";
  return Number(value).toLocaleString("fr-FR", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  });
};


export const getPermissionsFromToken = () => {
  const token = localStorage.getItem("token");
  if (!token) return [];
  try {
    const decoded = jwtDecode(token);
    return decoded?.permissions ?? [];
  } catch (e) {
    console.error("Token invalide", e);
    return [];
  }
};

export const hasPermission = (permissions = [], perm) =>
  permissions.includes(perm);